import styled, { css } from 'styled-components';

import { COLOR_WHITE, COLOR_GRAY_20, COLOR_GRAY_30, COLOR_GRAY_50 } from 'styles/variables/colors';
import glow from 'styles/animations/glow';

const commonStyle = css`
  border: 1px solid ${COLOR_GRAY_30};
  background: ${COLOR_WHITE};
  border-radius: 4px;
  padding: 6px;
  cursor: pointer;

  &:hover {
    border-color: ${COLOR_GRAY_50};
  }

  ${(props) =>
    props.isLoading &&
    css`
      animation: ${glow} 1.5s linear infinite;
      background: ${COLOR_GRAY_30};
    `}
`;

export const Button = styled.button`
  ${commonStyle}
`;

export const Anchor = styled.a`
  ${commonStyle}
`;

export const Image = styled.img`
  height: 88px;
  width: 117px;
  object-fit: cover;
`;

export const Loader = styled.div`
  animation: ${glow} 1.5s linear infinite;
  background: ${COLOR_GRAY_30};
  border-radius: 4px;
  width: 114px;
  min-width: 114px;
  height: 100px;
  margin: 0 13px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;
